// extracted by mini-css-extract-plugin
export default {"vectorIcon":"DateRangePickerModal_vectorIcon__YWhyP"};